export default {
  en: {
    title: "Timesheet Excel Template",
    description:
      "Time tracking is essential – whether you're a freelancer, agency, or small business. Our free Excel template brings structure to your workday – no subscription or setup required.",
    digitalise_time_tracking: "Digitalise time tracking?",
    test: "Try",
    our_smart_software:
      "our smart time tracking software for freelancers & small teams. Simple, clear, and efficient.",
    learn_more: "Learn more",
    free_excel_template: "Free Excel Timesheet Template",
    document_your_times:
      "Document your working hours professionally and easily – ideal for sharing with clients or for team billing.",
    download_for_free: "Download for free",
    why_excel_is_often_the_start: "Why Excel is often the start",
    why_excel_is_often_the_start_description:
      "Many start with Excel – flexible & free. But as the team grows, it quickly becomes confusing.",
    is_your_next_logical_step: "is your next logical step.",

    // SEO
    page_title:
      "Timesheet Excel Template | Time Tracking for Freelancers & Agencies",
    page_description:
      "Time tracking is essential – whether you're a freelancer, agency, or small business. Our free Excel template brings structure to your workday – no subscription or setup required.",
    page_keywords:
      "Time tracking, Excel template, timesheet template, time tracking for freelancers, time tracking for agencies, time tracking for small businesses, free time tracking, time tracking without subscription",
  },
  de: {
    title: "Zeiterfassung Excel-Vorlage",
    description:
      "Zeiterfassung ist essenziell – egal ob Freelancer, Agentur oder kleines Unternehmen. Unsere kostenlose Excel-Vorlage bringt Struktur in deinen Arbeitsalltag – ganz ohne Abo oder Setup.",
    digitalise_time_tracking: "Zeiterfassung digitalisieren?",
    test: "Teste",
    our_smart_software:
      "- unsere smarte Zeiterfassungs-Software für Freelancer & kleine Teams. Einfach, klar und effizient.",
    learn_more: "Mehr erfahren",
    free_excel_template: "Gratis Excel-Zeiterfassungsvorlage",
    document_your_times:
      "Dokumentiere deine Arbeitszeiten professionell und einfach – ideal zur Weitergabe an Kunden oder zur Abrechnung im Team.",
    download_for_free: "Kostenlos herunterladen",
    why_excel_is_often_the_start: "Warum Excel oft der Start ist",
    why_excel_is_often_the_start_description:
      "Viele starten mit Excel – flexibel & kostenlos. Doch bei wachsendem Team wird es schnell unübersichtlich.",
    is_your_next_logical_step: "ist dein nächster logischer Schritt.",

    // SEO
    page_title:
      "Zeiterfassung Excel-Vorlage | Zeiterfassung für Freelancer & Agenturen",
    page_description:
      "Zeiterfassung ist essenziell – egal ob Freelancer, Agentur oder kleines Unternehmen. Unsere kostenlose Excel-Vorlage bringt Struktur in deinen Arbeitsalltag – ganz ohne Abo oder Setup.",
    page_keywords:
      "Zeiterfassung, Excel-Vorlage, Zeiterfassungsvorlage, Zeiterfassung für Freelancer, Zeiterfassung für Agenturen, Zeiterfassung für kleine Unternehmen, Zeiterfassung kostenlos, Zeiterfassung ohne Abo",
  },
};
